import { DataGridPro, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, useGridApiRef, useGridSlotComponentProps } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useContext } from "react"
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from "../../services/api";
import MESSAGES from "../../services/messages"
import CustomToolbar from '../../components/grid/CustomToolbar'
import SL_Button from '../../components/buttons/Button'
import status_history_grid_columns from "./grid_columns/status_history_grid_columns";
import StatusFilters from './StatusFilters'

const { MONITOR_STATUS_HISTORY, MONITOR_STATUS_LIST } = MESSAGES

export default function ListPatient() {

    const {
        setShowLoading, user, enums,
        windowWidth, windowHeight, mobile_mode
    } = useContext(GeneralContext)

    const gridRef = useGridApiRef()

    const DataGridProHeight = windowHeight * 0.7

    const [statusHistory, setStatusHistory] = useState([])
    const [currentStatusHistory, setcurrentStatusHistory] = useState([])



    useEffect(() => {
        loadStatusHistory()
    }, [])

    const loadStatusHistory = async (currentFilters) => {
        try {
            setShowLoading(true)
            const payload = { ...currentFilters }
            const rs = await api.monitor.listStatuHistory(payload)
            gridRef.current.setSelectionModel([])
            setStatusHistory(rs.data)

        } finally {
            setShowLoading(false)
        }
    }

    const handleRowChange = (e) => {
        setcurrentStatusHistory(e?.row)
    }

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport
                    csvOptions={{ delimiter: ';' }}
                    onClick={
                        () => {
                            gridRef.setSelectionModel([])
                        }
                    }

                />


            </GridToolbarContainer>
        )
    }


    return (
        <>
            <StatusFilters handleOnSearchSatusHistory={loadStatusHistory} />

            <div className='flex flex-col w-full'>

                <div style={{ height: DataGridProHeight, minHeight: 300 }} >
                    {
                        enums &&

                        <DataGridPro
                            rows={statusHistory}
                            apiRef={gridRef}
                            style={{ height: '100%' }}
                            columns={status_history_grid_columns(enums)}
                            pagination
                            pageSize={100}
                            components={{
                                Toolbar: CustomToolbar,
                            }}
                            onRowClick={handleRowChange}
                            density="compact"
                            disableMultipleSelection
                            disableSelectionOnClick
                        />

                    }

                </div>
            </div>
        </>
    )
}